import { type InsuranceCorporateIdentity } from "../types";

export function ContinentaleLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M424.037 285.558C410.963 365.408 341.261 426.21 257.503 426.21C164.42 426.21 89.0628 350.941 89.0628 258.07C89.0628 165.2 164.52 89.9513 257.503 89.9513C282.147 89.9513 316.136 99.5759 326.643 104.7C337.151 109.823 378.659 131.886 378.659 131.886V68.4918H355.037V91.9405C325.352 74.8879 291.72 65.943 257.503 66.0003C151.225 66.0003 65 151.959 65 257.99C65 364.021 151.225 450 257.503 450C303.655 450.024 348.279 433.433 383.246 403.249C418.212 373.065 441.193 331.298 448 285.558H424.037Z"
        fill="white"
      />
      <path
        d="M307.098 135.104C289.058 127.748 269.613 124.489 250.165 125.561C230.716 126.634 211.746 132.011 194.621 141.307C177.495 150.603 162.64 163.586 151.123 179.321C139.606 195.057 131.714 213.155 128.015 232.311C124.316 251.468 124.903 271.208 129.732 290.111C134.561 309.013 143.512 326.609 155.943 341.631C168.373 356.653 183.973 368.728 201.62 376.988C219.267 385.247 238.522 389.486 258 389.398C288.187 389.422 317.474 379.099 340.996 360.145C364.518 341.192 380.859 314.748 387.305 285.206H411.533C404.438 323.464 383.357 357.697 352.408 381.215C321.459 404.732 282.868 415.844 244.177 412.378C205.486 408.913 169.475 391.119 143.182 362.474C116.89 333.829 102.206 296.392 102 257.48C102 171.57 171.837 101.914 258 101.914C274.647 101.914 285.076 104.204 297.592 106.957C322.602 112.482 359.667 135.325 390.353 152.282C390.353 152.142 390.353 68 390.353 68H414V194.574C414 194.574 333.352 145.472 307.098 134.944"
        fill="white"
      />
      <path
        d="M293.6 168.556C287.427 165.719 270.415 161.694 257.746 161.694C239.977 161.799 222.586 166.839 207.51 176.251C192.434 185.664 180.265 199.08 172.358 215.005C164.452 230.93 161.118 248.739 162.729 266.448C164.34 284.158 170.832 301.072 181.482 315.306C192.132 329.541 206.521 340.538 223.048 347.072C239.574 353.605 257.589 355.42 275.085 352.312C292.581 349.205 308.872 341.297 322.142 329.471C335.413 317.645 345.142 302.365 350.246 285.332H374.377C369.272 307.281 358.086 327.344 342.103 343.219C326.12 359.094 305.988 370.137 284.018 375.081C262.048 380.025 239.13 378.669 217.895 371.169C196.66 363.669 177.968 350.329 163.966 332.68C149.963 315.032 141.217 293.789 138.732 271.392C136.246 248.994 140.122 226.349 149.914 206.056C159.706 185.763 175.018 168.644 194.092 156.665C213.165 144.686 235.228 138.331 257.746 138.331C272.25 138.282 286.639 140.902 300.196 146.058C321.531 154.993 425.352 214.9 425.352 214.9V68H449V258.246C449 258.246 324.065 182.643 293.56 168.617"
        fill="white"
      />
    </svg>
  );
}

export function ContinentaleBackground({
  className,
  width = "512",
}: {
  className?: string;
  width?: string;
}) {
  return (
    <svg
      width={width}
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <svg
        width="512"
        height="512"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="512" height="512" fill="url(#paint0_linear_31_4494)" />
        <defs>
          <linearGradient
            id="paint0_linear_31_4494"
            x1="0"
            y1="256"
            x2="512"
            y2="256"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C01953" />
            <stop offset="1" stop-color="#002C5B" />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  );
}

export const Continentale: InsuranceCorporateIdentity = {
  id: "continentale",
  name: "Continentale",
  logo: ContinentaleLogo,
  backgroundColor: "#C01953",
  background: ContinentaleBackground,
  textColor: "#FFFFFF",
  wildcard: "continentale",
  type: "statutory",
};
